import { render, staticRenderFns } from "./NextResult.vue?vue&type=template&id=18dee2ae&scoped=true&"
import script from "./NextResult.vue?vue&type=script&lang=js&"
export * from "./NextResult.vue?vue&type=script&lang=js&"
import style0 from "./NextResult.vue?vue&type=style&index=0&id=18dee2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dee2ae",
  null
  
)

export default component.exports